import {actionTypes} from './../constants/auth';

const actions = {
    getToken: () => ({
        type: actionTypes.GET_TOKEN
    }),
    setToken: (token) => ({
        type: actionTypes.SET_TOKEN,
        payload: {token}
    }),
    unsetToken: () => ({
        type: actionTypes.UNSET_TOKEN
    }),
    setProfile: (profile)=> ({
        type: actionTypes.SET_PROFILE,
        payload: {profile}
    }),
    unsetProfile: () => ({
        type: actionTypes.UNSET_PROFILE
    })
}

export { actions };